import { FormGroup, Validators } from '@angular/forms';

import { EventTicketValidationAction } from './event-ticket-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';

export class EventTicketRules extends FormModel<EventTicketValidationAction> {
    baseValidators: FieldValidatorsMap = {
        amountAvailable: [Validators.min(0)],
        name: [Validators.required],
        price: [Validators.required],
        purchasaleFrom: [],
        purchasableUntil: [],
        sportIdPrice: [Validators.required],
    };
    formValidators: FormValidatorsMap = {};

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventTicketValidationAction.Store, formFrom);
    }

    getUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventTicketValidationAction.Update, formFrom);
    }
}
